'use client';

import { c as _c } from "react/compiler-runtime";
import { AuthShell } from '@/components/auth/auth-shell';
import { LoginForm } from '@/components/auth/login-form';
interface LoginPageProps {
  redirect?: string;
}
export default function LoginPage(t0) {
  const $ = _c(2);
  const {
    redirect
  } = t0;
  let t1;
  if ($[0] !== redirect) {
    t1 = <AuthShell activeTab="signin" data-sentry-element="AuthShell" data-sentry-component="LoginPage" data-sentry-source-file="login-page.tsx"><LoginForm redirect={redirect} data-sentry-element="LoginForm" data-sentry-source-file="login-page.tsx" /></AuthShell>;
    $[0] = redirect;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}